import apiServiceHandler from "./APIServiceHandler";
import { AddPollURL, DeletePollURL, EditPollURL, GetPollsAdminURL, GetPollURL, GetPollWithUserIdURL, LoginURL, GetBulletinURL, SendNoteToEmailURL, GetTeamLeadsURL, OptLunchURL, GetLunchOptedUsersURL, GetJournalsURL, AddJournalURL, DeleteJournalURL, GetTeamJournalsURL, AddTLFeedbackURL, ActionURL, GetAllJournalsURL } from "./URLConstance";

interface LoginUserPayload {
    password: string;
    username: string;
}
export interface LoginUserResponsePayload {
    password: string;
    email: string;
    device_token: string;
    token: string;
    user_id: number;
    user_name: string;
    role: string;
}


export interface GetPollPayload {
    date: string
}
export interface GetPollWithUserIdPayload {
    date: string,
    username: string
}
export interface SubmitPollPayload {
    username?: string,
    foodChoice: string,
    pollDate: string,
    emp_name?: string
}
export interface EditPollPayload {
    foodChoice: string,
    pollDate: string,
}

export interface deletePollPayload {
    username: string
}

export interface BulletinMessage {
    id: string
    title: string
    message: string
    sender: string
    date: string
    priority: "high" | "medium" | "low"
    createdAt: string
}

export interface SendNotePayload {
    username: string
    email: string
    subject: string
    message: string
}

export interface OptLunchPayload {
    username: string
    lunchOpted: boolean
}

export interface JournalPayload {
    dateOfJournal: string
    feedbackType: string
    feedbackCategory: string
    employeeFeedback: string
    tlFeedback: string
}

export const LoginUser = async (userData: LoginUserPayload) => {
    try {
        const response = await apiServiceHandler.post<any>(LoginURL, userData);
        return response;
    } catch (error) {
        console.error('LoginUser user:', error);
    }
};

export const GetPoll = async (polldata: GetPollPayload) => {
    try {
        const response = await apiServiceHandler.get<any>(GetPollURL, polldata);
        return response;
    } catch (error) {
        console.error('Log FetchAppointments Details:', error);
    }
};
export const GetPollWithUserId = async (polldata: GetPollWithUserIdPayload) => {
    try {
        const response = await apiServiceHandler.get<any>(GetPollWithUserIdURL, polldata);
        return response;
    } catch (error) {
        console.error('Log FetchAppointments Details:', error);
    }
};

export const SubmitPoll = async (polldata: SubmitPollPayload) => {
    try {
        const response = await apiServiceHandler.post<any>(AddPollURL, polldata);
        return response;
    } catch (error) {
        console.error('Log FetchAppointments Details:', error);
    }
};

export const EditPoll = async (polldata: EditPollPayload) => {
    try {
        const response = await apiServiceHandler.put<any>(EditPollURL, polldata);
        return response;
    } catch (error) {
        console.error('Log FetchAppointments Details:', error);
    }
};
export const GetPollAdmin = async (polldata: GetPollPayload) => {
    try {
        const response = await apiServiceHandler.get<any>(GetPollsAdminURL, polldata);
        return response;
    } catch (error) {
        console.error('Log FetchAppointments Details:', error);
    }
};
export const DeletePoll = async (deletePollData: deletePollPayload) => {
    try {
        const DeletePollURLWIthData = `${DeletePollURL}${deletePollData.username}`;
        const response = await apiServiceHandler.delete<any>(DeletePollURLWIthData);
        return response;
    } catch (error) {
        console.error('Log DeletePoll Details:', error);
    }
};


export const SendNoteToEmail = async (noteData: SendNotePayload) => {
    try {
        const response = await apiServiceHandler.post<any>(SendNoteToEmailURL, noteData);
        return response;
    } catch (error) {
        console.error('Log SendNoteToEmail Details:', error);
    }
};

export const GetTeamLeads = async () => {
    try {
        const response = await apiServiceHandler.get<any>(GetTeamLeadsURL);
        return response?.data?.users || [];
    } catch (error) {
        console.error('Log GetTeamLeads Details:', error);
        return [];
    }
}

export const OptLunch = async (optLunchData: OptLunchPayload) => {
    try {
        const response = await apiServiceHandler.post<any>(OptLunchURL, optLunchData);
        return response;
    } catch (error) {
        console.error('Log OptLunch Details:', error);
    }
}

export const GetLunchOptedUsers = async () => {
    try {
        const response = await apiServiceHandler.get<any>(GetLunchOptedUsersURL);
        return response?.data?.users || [];
    } catch (error) {
        console.error('Log GetLunchOptedUsers Details:', error);
        return [];
    }
}

export const GetJournals = async () => {
    try {
        const response = await apiServiceHandler.get<any>(GetJournalsURL);
        console.log('Log GetJournals Details:', response);
        return response?.data || [];
    } catch (error) {
        console.error('Log GetJournals Details:', error);
        return [];
    }
}

export const AddJournal = async (journalData: JournalPayload | FormData) => {
    try {
        let response;
        if (journalData instanceof FormData) {
            response = await apiServiceHandler.post<any>(AddJournalURL, journalData);
        } else {
            // For JSON, set Content-Type header
            response = await apiServiceHandler.post<any>(AddJournalURL, journalData, { 'Content-Type': 'application/json' });
        }
        return response;
    } catch (error) {
        console.error('Log AddJournal Details:', error);
    }
}

export const DeleteJournal = async (journalId: string) => {
    try {
        const url = `${DeleteJournalURL}${journalId}`;
        const response = await apiServiceHandler.delete<any>(url);
        return response;
    } catch (error) {
        console.error('Log DeleteJournal Details:', error);
    }
}

export const GetTeamJournals = async (teamLead: string) => {
    try {
        const response = await apiServiceHandler.get<any>(GetTeamJournalsURL, { teamLead });
        return response?.data || [];
    } catch (error) {
        console.error('Log GetTeamJournals Details:', error);
        return [];
    }
}

export const AddTLFeedback = async (feedbackData: { journalId: string, tlFeedback: string }) => {
    try {
        const url = `${AddTLFeedbackURL}${feedbackData.journalId}`;
        const response = await apiServiceHandler.put<any>(url, { tlFeedback: feedbackData.tlFeedback });
        return response;
    } catch (error) {
        console.error('Log AddTLFeedback Details:', error);
    }
}

export const UpdateJournalAction = async (journalId: string, action: boolean) => {
    try {
        const url = `${ActionURL}${journalId}`;
        const response = await apiServiceHandler.put<any>(url, { action });
        return response;
    } catch (error) {
        console.error('Log UpdateJournalAction Details:', error);
    }
}

export const GetAllJournals = async () => {
    try {
        const response = await apiServiceHandler.get<any>(GetAllJournalsURL);
        return response?.data || [];
    } catch (error) {
        console.error('Log GetAllJournals Details:', error);
        return [];
    }
}